(function () {
  'use strict';

  if (window.BabyOrganoUpsell && window.BabyOrganoUpsell._ready) return;

  const U = window.BabyOrganoUpsell = { _ready: true };

  // ── Internal state ────────────────────────────────────────────────────────────
  let _modal    = null;
  let _mainItem = null;
  let _atcBtn   = null;
  const _selected = new Set();

  // ── Private helpers ───────────────────────────────────────────────────────────

  function _restoreAtcBtn() {
    if (!_atcBtn) return;
    var span = _atcBtn.querySelector('.txt, .btnin');
    var spin = _atcBtn.querySelector('.loading-overlay__spinner');
    if (span) span.classList.remove('hidden');
    if (spin) spin.classList.add('hidden');
    _atcBtn = null;
  }

  function _variantFromCard(card) {
    var swatch = card.querySelector('.usp-swatch--active');
    if (swatch) return parseInt(swatch.dataset.variantId, 10);
    var inp = card.querySelector('.usp-variant-id');
    if (inp) return parseInt(inp.value, 10);
    return null;
  }

  function _updateCta() {
    const n = _selected.size;
    const isSingle = _modal.classList.contains('usp-single');
    _modal.querySelector('.usp-cta-text').textContent = isSingle
      ? 'Add to Cart'
      : (n > 0 ? 'Add to Cart (' + n + ' selected)' : 'Add to Cart (0 selected)');
    _modal.querySelector('.usp-cta').disabled = n === 0;
  }

  function _showError(msg) {
    _modal.querySelector('.usp-error-msg').textContent =
      msg || 'Something went wrong. Please try again.';
    _modal.querySelector('.usp-error').removeAttribute('hidden');
  }

  function _hideError() {
    _modal.querySelector('.usp-error').setAttribute('hidden', '');
  }

  function _setLoading(on) {
    const btn     = _modal.querySelector('.usp-cta');
    const text    = _modal.querySelector('.usp-cta-text');
    const spinner = _modal.querySelector('.usp-spinner');
    if (on) {
      btn.disabled = true;
      text.setAttribute('hidden', '');
      spinner.removeAttribute('hidden');
    } else {
      text.removeAttribute('hidden');
      spinner.setAttribute('hidden', '');
      _updateCta();
    }
  }

  function _track(eventType, extra) {
    var handle = (_modal && _modal.dataset.productHandle) || '';
    var pathname = window.location.pathname;
    var pageType = 'other';
    if (pathname === '/' || pathname === '') pageType = 'home';
    else if (pathname.indexOf('/products/') !== -1) pageType = 'product';
    else if (pathname.indexOf('/collections/') !== -1) pageType = 'collection';
    else if (pathname.indexOf('/cart') !== -1) pageType = 'cart';
    else if (pathname.indexOf('/pages/') !== -1) pageType = 'page';
    else if (pathname.indexOf('/blogs/') !== -1) pageType = 'blog';
    else if (pathname.indexOf('/search') !== -1) pageType = 'search';
    var colMatch = pathname.match(/\/collections\/([^\/]+)/);
    var payload = Object.assign({
      event_type: eventType,
      source_handle: handle,
      page_type: pageType,
      page_url: window.location.href,
      collection: colMatch ? colMatch[1] : '',
      visible_count: 0,
      selected_count: 0,
      selected_ids: []
    }, extra || {});
    fetch('https://babyorgano.in/upsell-analytics/api/track.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function () {});
  }

  function _cartAdd(items, onOk, onErr) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) {
      return r.text().then(function (text) {
        var data;
        try { data = JSON.parse(text); } catch (e) {
          return Promise.reject({ description: 'Could not add to cart. Please try again.' });
        }
        if (!r.ok) return Promise.reject(data);
        return data;
      });
    })
    .then(function (data) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: data })
      );
      if (onOk) onOk(data);
    })
    .catch(function (err) {
      if (onErr) onErr(err);
    });
  }

  // ── Modal open / close ────────────────────────────────────────────────────────

  function _open(el, item) {
    _modal = el;
    _mainItem = item;
    _selected.clear();
    var visibleCards = el.querySelectorAll('.usp-card:not(.usp-card--hidden)').length;
    _track('impression', { visible_count: visibleCards });

    el.querySelectorAll('.usp-card.usp-selected').forEach(function (card) {
      card.classList.remove('usp-selected');
      var btn = card.querySelector('.usp-toggle-btn');
      if (btn) { btn.textContent = 'Add'; btn.classList.remove('usp-toggle-btn--remove'); }
    });

    if (el.classList.contains('usp-single')) {
      var singleCard = el.querySelector('.usp-card:not(.usp-card--hidden)');
      if (singleCard) _selected.add(singleCard.dataset.productId);
    }

    _hideError();
    _updateCta();
    _restoreAtcBtn();
    el.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('upsell-open');
    el.querySelector('.usp-sheet').focus();
  }

  function _close() {
    if (!_modal) return;

    _restoreAtcBtn();
    document.body.classList.remove('upsell-open');

    var el    = _modal;
    var sheet = el.querySelector('.usp-sheet');

    _modal    = null;
    _mainItem = null;
    _selected.clear();

    var finished = false;
    function onDone() {
      if (finished) return;
      finished = true;
      sheet.classList.remove('usp-closing');
      el.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    sheet.classList.add('usp-closing');
    sheet.addEventListener('animationend', onDone, { once: true });
    setTimeout(onDone, 400);
  }

  // ── User actions ─────────────────────────────────────────────────────────────

  function _skip() {
    var item = _mainItem;
    _track('skip', { selected_count: _selected.size, selected_ids: Array.from(_selected) });
    _cartAdd([item], null, null);
    _close();
  }

  function _addWithUpsells() {
    if (_selected.size === 0) return;

    var sourceHandle = _modal.dataset.productHandle || '';
    var items = [_mainItem];
    _selected.forEach(function (pid) {
      var card = _modal.querySelector('.usp-card[data-product-id="' + pid + '"]');
      var vid  = card ? _variantFromCard(card) : null;
      if (vid) items.push({
        id: vid,
        quantity: 1,
        properties: { '_source': 'pdp_upsell', '_source_handle': sourceHandle }
      });
    });

    var selectedIds = Array.from(_selected);
    var selectedHandles = selectedIds.map(function(pid) {
      var card = _modal.querySelector('.usp-card[data-product-id="' + pid + '"]');
      return card ? (card.dataset.productHandle || '') : '';
    }).filter(Boolean);
    _track('converted', { selected_count: selectedIds.length, selected_ids: selectedIds, selected_handles: selectedHandles });
    _cartAdd(items, null, null);
    _close();
  }

  // ── Public API ────────────────────────────────────────────────────────────────

  U.check = function (sectionId, variantId, quantity, props, atcBtn) {
    var el = document.getElementById('upsell-modal-' + sectionId);
    if (!el) return false;

    _atcBtn = atcBtn || null;

    var item = { id: parseInt(variantId, 10), quantity: quantity, properties: props };

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = new Set(cart.items.map(function (i) { return String(i.product_id); }));

        var visibleCount = 0;
        el.querySelectorAll('.usp-card').forEach(function (card) {
          card.classList.remove('usp-card--hidden');
          if (inCart.has(card.dataset.productId)) {
            card.classList.add('usp-card--hidden');
          } else {
            visibleCount++;
          }
        });

        el.classList.toggle('usp-single', visibleCount === 1);

        if (visibleCount === 0) {
          _restoreAtcBtn();
          _cartAdd([item], null, null);
        } else {
          _open(el, item);
        }
      })
      .catch(function () {
        _restoreAtcBtn();
        _cartAdd([item], null, null);
      });

    return true;
  };

  // _wire: portal modal to <body> and attach all event listeners.
  // data-usp-wired guard prevents double-wiring (MutationObserver fires again
  // after body.appendChild moves the element — the guard stops re-entry).
  U._wire = function (sectionId) {
    var el = document.getElementById('upsell-modal-' + sectionId);
    if (!el || el.dataset.uspWired) return;
    el.dataset.uspWired = '1';

    document.body.appendChild(el);

    el.querySelector('.usp-backdrop').addEventListener('click', function () {
      if (_modal === el) _skip();
    });
    el.querySelector('.usp-skip').addEventListener('click', function () {
      if (_modal === el) _skip();
    });
    el.querySelector('.usp-cta').addEventListener('click', function () {
      if (_modal === el) _addWithUpsells();
    });
    el.querySelector('.usp-retry').addEventListener('click', function () {
      if (_modal === el) { _hideError(); _skip(); }
    });

    el.querySelectorAll('.usp-card:not(.usp-oos)').forEach(function (card) {
      var toggleBtn = card.querySelector('.usp-toggle-btn');
      if (!toggleBtn) return;
      toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var pid = card.dataset.productId;
        if (_selected.has(pid)) {
          _selected.delete(pid);
          card.classList.remove('usp-selected');
          toggleBtn.textContent = 'Add';
          toggleBtn.classList.remove('usp-toggle-btn--remove');
        } else {
          _selected.add(pid);
          card.classList.add('usp-selected');
          toggleBtn.textContent = 'Remove';
          toggleBtn.classList.add('usp-toggle-btn--remove');
        }
        _hideError();
        _updateCta();
      });
    });

    el.querySelectorAll('.usp-swatch:not(.usp-swatch--oos)').forEach(function (swatch) {
      swatch.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = swatch.closest('.usp-card');

        card.querySelectorAll('.usp-swatch').forEach(function (s) {
          s.classList.remove('usp-swatch--active');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('usp-swatch--active');
        swatch.setAttribute('aria-pressed', 'true');

        var newImg = swatch.dataset.variantImg;
        if (newImg) {
          var cardImg = card.querySelector('.usp-card-img');
          if (cardImg) cardImg.src = newImg;
        }

        var optVal = card.querySelector('.usp-swatch-opt-val');
        if (optVal && swatch.dataset.variantOption) optVal.textContent = swatch.dataset.variantOption;
      });
    });
  };

  // _wireAll: wire every unwired .usp-modal currently in the DOM
  U._wireAll = function () {
    document.querySelectorAll('.usp-modal[id]:not([data-usp-wired])').forEach(function (el) {
      var sectionId = el.id.replace('upsell-modal-', '');
      if (sectionId) U._wire(sectionId);
    });
  };

  // Global ESC handler
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && _modal) _skip();
  });

  // Wire modals already in the DOM at script-load time
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { U._wireAll(); });
  } else {
    U._wireAll();
  }

  // MutationObserver: auto-wire modals injected later via innerHTML
  // (collection filter updates, infinite scroll, section re-renders)
  if (window.MutationObserver) {
    var _observer = new MutationObserver(function (mutations) {
      var needsWire = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Direct match
          if (node.classList && node.classList.contains('usp-modal') && !node.dataset.uspWired) {
            needsWire = true;
          }
          // Descendant modals (entire grid injected at once)
          if (!needsWire && node.querySelector && node.querySelector('.usp-modal:not([data-usp-wired])')) {
            needsWire = true;
          }
        });
      });
      if (needsWire) U._wireAll();
    });

    _observer.observe(document.documentElement, { childList: true, subtree: true });
  }

}());


document.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.close-usp');
  if (!closeBtn) return;

  const modal = closeBtn.closest('.usp-modal');
  const skipBtn = modal?.querySelector('.usp-skip');

  if (skipBtn) {
    skipBtn.click();
  }
});